var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    fill: "none",
    viewBox: "0 0 15 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check-mark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3EC59D",
    d: "M14.429 0H13.18a.57.57 0 0 0-.449.218L5.37 9.545 1.84 5.07a.57.57 0 0 0-.449-.217H.143a.142.142 0 0 0-.112.23l4.89 6.196c.23.29.669.29.899 0L14.54.23A.141.141 0 0 0 14.43 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check-mark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v12H0z"
  })))));
};
export default SvgCheckMark;